import { render } from "./DevHostSelect.vue?vue&type=template&id=189ba988"
import script from "./DevHostSelect.vue?vue&type=script&lang=js"
export * from "./DevHostSelect.vue?vue&type=script&lang=js"

import "./DevHostSelect.vue?vue&type=style&index=0&id=189ba988&lang=css"

import exportComponent from "/codebuild/output/src2517490718/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__